import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'contact/autocomplete';

export function useContactAutocomplete({
	enabled,
	fragment,
	pageSize,
	enforcePageSize = true,
	searchFields,
	groupByDuplicate = false,
}: {
	enabled?: boolean;
	fragment: string;
	pageSize: number;
	enforcePageSize?: boolean;
	searchFields?: string;
	groupByDuplicate?: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IContact>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: {
						enforcePageSize,
						fragment,
						groupByDuplicate,
						pageSize,
						searchFields,
						pageToken: pageParam,
					},
					urlPath: 'contact/autocomplete',
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, fragment, pageSize, enforcePageSize, groupByDuplicate, searchFields],
		initialPageParam: '',
	});
}
